import { useState, useEffect, useCallback, useContext, useRef } from "react";
import { ReactSession } from "react-client-session";
import Modal from "@mui/material/Modal";
import { getSuccessToast, getErrorToast } from "../../toast";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

import EntriesDataContext from "../../context/EntriesDataContext";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { toast } from "react-toastify";

import "./ManualEntryTable.css";
import bin from "../../assets/bin.svg";

const ManualEntryTable = () => {
  const boxId = ReactSession.get("box_id_s");
  const { redirectId, setRedirectId } = useContext(EntriesDataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [medData, setMedData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [batchNo, setBatchNo] = useState();
  const [quantity, setQuantity] = useState();
  const [expiryStatus, setExpiryStatus] = useState("");
  const [expStatVal, setExpStatVal] = useState("");
  const [currSelectedData, setCurrSelectedData] = useState();

  const [materialDesc, setMaterialDesc] = useState();
  const [div, setDiv] = useState();
  const [divName, setDivName] = useState();
  const [pack, setPack] = useState();
  const [materialNo, setMaterialNo] = useState();
  const [mfgDate, setMfgDate] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [mrp, setMrp] = useState();
  const [date, setDate] = useState();
  const [checked, setChecked] = useState(false);

  const [medId, setMedId] = useState();
  const [editState, setEditState] = useState(false);
  const [open, setOpen] = useState(false);
  const [searched, setSearched] = useState("");
  const [tableType, setTableType] = useState("groupBy");
  const [tableData, setTableData] = useState();
  const axiosPrivate = useAxiosPrivate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const batchNoRef = useRef();
  const materialDescRef = useRef("");
  const divRef = useRef("");
  const divNameRef = useRef("");
  const packRef = useRef("");
  const materialNoRef = useRef("");
  const mfgDateRef = useRef("");
  const expiryDateRef = useRef("");
  const mrpRef = useRef("");
  const quantityRef = useRef();
  const dateRef = useRef("");
  const expiryStatusRef = useRef("");
  const checkedRef = useRef();

  const columns = [
    {
      id: "batch_no",
      label: "Batch No",
      minWidth: "10%",
    },
    {
      id: "material_desc",
      label: "Material Desc",
      minWidth: "10%",
    },
    {
      id: "product_code",
      label: "Product Code",
      minWidth: "10%",
    },
    {
      id: "quantity",
      label: "Quantity",
      minWidth: "4%",
    },
    {
      id: "invoice",
      label: "Invoice",
      minWidth: "4%",
    },
    {
      id: "mrp",
      label: "MRP",
      minWidth: "6%",
    },
    {
      id: "expiry_status",
      label: "Status",
      minWidth: "8%",
    },
    {
      id: "breakage",
      label: "Breakage",
      minWidth: "4%",
    },
    {
      id: "division",
      label: "Division",
      minWidth: "5%",
    },
    {
      id: "plant",
      label: "Plant",
      minWidth: "5%",
    },
    {
      id: "pack",
      label: "Pack",
      minWidth: "5%",
    },

    {
      id: "mfg_date",
      label: "MFG Date",
      minWidth: "5%",
    },
    {
      id: "exp_date",
      label: "Expiry Date",
      minWidth: "5%",
    },

    {
      id: "date",
      label: "Date",
      minWidth: "5%",
    },
  ];

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  const getBoxData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await axiosPrivate.get(`/dashboard/boxdetails/${boxId}/0`);

      setMedData(res.data.data);
      setRowData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectId]);

  useEffect(() => {
    getBoxData();
  }, [getBoxData]);

  useEffect(() => {
    if (searched.length >= 3) {
      const filteredData = rowData.filter((row) => {
        return row.medicine_master__batch_number
          .toLowerCase()
          .includes(searched.toLowerCase());
      });

      setMedData(filteredData);
    } else if (searched.length === 0) {
      setMedData(rowData);
    }
  }, [rowData, searched]);

  const submitHandler = (id) => {
    if (batchNo === "") {
      getErrorToast("Please select a batch number from list.");
      setBatchData([]);
      return;
    }

    if (quantity === "0" || quantity === undefined || quantity === "") {
      getErrorToast("The unit field  is required.");
      return;
    }
    if (quantity < "0") {
      getErrorToast("Unit can't be negative.");
      return;
    }
    let regex = /[.*]./g;
    if (quantity.toString().match(regex)) {
      getErrorToast("Unit can't be decimals");
      return;
    }
    const data = {
      batch_number: batchNo,
      quantity: quantity,
      box_medicine_data_master_id: id,
      description: materialDesc,
      goods_type: expiryStatusRef.current.value,
      mrp: mrp,
    };

    axiosPrivate
      .patch(`/data_entry/update_entry/${ReactSession.get("box_id")}`, data)
      .then((res) => {
        if (res.status === 200) {
          getSuccessToast("Data updated successfully", 2000);
          setRedirectId((prev) => prev + 1);
        }
      });
    setEditState(false);
  };

  const confirmDelteHandler = () => {
    const medicineId = { box_medicine_data_master_id: medId };
    const headers = {
      "Content-Type": "application/json",
    };
    axiosPrivate
      .delete(
        `/data_entry/update_entry/${ReactSession.get("box_id")}`,
        {
          data: medicineId,
        },
        headers
      )
      .then((res) => {
        if (res.status === 204) {
          // getSuccessToast("Entry deleted successfully", 2000);
          toast.success("Entry deleted successfully", {
            theme: "colored",
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setRedirectId((prev) => prev - 10);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    setOpen(false);
  };

  const handleClose = () => setOpen(false);

  const searchTableHandler = (e) => {
    setSearched(e.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const dropDownAPI = (e) => {
    axiosPrivate
      .get(
        `/data_entry/batch_number/?search=${
          e.target.value
        }&box_id=${ReactSession.get("box_id")}`
      )
      .then((res) => {
        setBatchData(res.data);
      });
  };

  const checkBoxHandler = (e) => {
    if (checkedRef.current.checked) {
      expiryStatusRef.current.value = "BREAKAGE";
    } else if (
      !checkedRef.current.checked &&
      expiryStatusRef.current.value === "BREAKAGE"
    ) {
      expiryStatusRef.current.value = expStatVal;
    } else {
    }
  };

  const changeTableHandler = (e) => {
    setTableType(e.target.value);

    if (e.target.value !== "groupBy") {
      let headerData = null;
      if (e.target.value === "medicine_master__batch_number") {
        headerData = `<thead>
          <tr >
            <th>Sr No.</th>
            <th>Batch Number</th>
            <th>Medicine Name</th>
            <th>Material Code</th>
            <th>Total Quantity</th>
            <th>Reason</th>
            <th>Expiry Date</th>
            <th>Quantity</th>
            <th>MRP</th>
          </tr>
        </thead>`;
      } else {
        headerData = `<thead>
          <tr >
            <th>Sr No.</th>
            <th>Medicine Name</th>
            <th>Material Code</th>
            <th>Total Quantity</th>
            <th>Reason</th>
            <th>Expiry Date</th>
            <th>Quantity</th>
            <th>MRP</th>
          </tr>
        </thead>`;
      }
      setIsLoading(true);

      axiosPrivate
        .get(`/dashboard/group_by/${boxId}?field_name=${e.target.value}`)
        .then((res) => {
          document.querySelector("#group_by_table_container").innerHTML =
            res.data;

          document.querySelector(".dataframe thead").remove();

          document
            .querySelector(".dataframe")
            .insertAdjacentHTML("afterbegin", headerData);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
  };

  const downloadExcel = async () => {
    const partyINFO = await axiosPrivate.get(
      `/data_entry/party-info/${boxId}/`
    );
    axiosPrivate(`/report/download-group-by/${boxId}?field_name=${tableType}`, {
      responseType: "blob",
    }).then((response) => {
      let date = new Date();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${partyINFO.data["party_code"]}_${
          partyINFO.data["lr_number"]
        }_${formatDate(date)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  return (
    <div>
      <div
        className={
          tableType === "groupBy"
            ? "manual-entries-header-container"
            : "manual-entries-header-container-html-data"
        }
      >
        {tableType === "groupBy" && (
          <div className="manual-entries-header-section">
            {/*<p className="manual-entries-header-name">Recent Entries</p>*/}
            <input
              placeholder="Search By Batch No"
              className="manual-entries-header-input"
              type="text"
              value={searched}
              onChange={searchTableHandler}
            />
          </div>
        )}

        <div
          className={
            tableType === "groupBy"
              ? "manual-entries-select-section"
              : "manual-entries-select-container-html-table"
          }
        >
          <select
            onChange={changeTableHandler}
            className="manual-entries-select-container"
            disabled={isLoading}
          >
            <option value="groupBy">---Group By----</option>
            <option value="medicine_master__batch_number">
              Group by Batch Number
            </option>
            <option value="medicine_master__description">
              Group by Medicine Name
            </option>
          </select>
        </div>
        {tableType !== "groupBy" && (
          <div className="manual-entries-download-html-data">
            <button
              className="manual-entries-download-html-data-btn"
              onClick={downloadExcel}
            >
              Download
            </button>
          </div>
        )}
        {tableType === "groupBy" && (
          <TablePagination
            rowsPerPageOptions={[50, 100, 200]}
            component="div"
            count={medData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>

      <div>
        <Paper
          style={{
            overflow: "hidden",
          }}
        >
          <Modal open={open} onClose={handleClose}>
            <div className="delete-modal">
              <div className="delete-modal-desc">
                <img alt="bin" className="delete-modal-img" src={bin} />
                <p className="delete-modal-desc-para dmdp-1">
                  You are about to delete a Record!
                </p>
                <p className="delete-modal-desc-para dmdp-2">
                  This will delete your record!
                </p>
                <p className="delete-modal-desc-para dmdp-3">Are you sure?</p>
              </div>
              <div className="delete-modal-btns">
                <button
                  onClick={handleClose}
                  className="delete-modal-btn dmb-1"
                  id="yes"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelteHandler}
                  className="delete-modal-btn dmb-2"
                  id="no"
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal>

          <TableContainer sx={{ maxHeight: "80vh" }}>
            {tableType === "groupBy" ? (
              <Table stickyHeader aria-label="sticky table">
                <TableHead className="manual-entries-table-head">
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          width: column.minWidth,
                          fontSize: "0.75em",
                          padding: "0.75em",
                          textAlign: "center",
                          textTransform: "uppercase",
                          color: "white",
                          backgroundColor: "#000000",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {medData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.box_medicine_data_master_id}>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          <div>{row.medicine_master__batch_number}</div>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                ref={materialDescRef}
                                value={materialDesc}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__description}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={materialNoRef}
                                value={materialNo}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__material}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                type="number"
                                style={{
                                  width: "100%",
                                }}
                                className="manualentry-input manualentry-edit-input"
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                              />
                            </div>
                          ) : (
                            <div>{row.quantity}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                            <div>{row.invoice}</div>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={mrpRef}
                                value={mrp}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__mrp}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={expiryStatusRef}
                                value={expiryStatus}
                              />
                            </div>
                          ) : (
                            <div>{row.goods_type}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <input
                              // checked={checked}
                              type="checkbox"
                              onChange={checkBoxHandler}
                              ref={checkedRef}
                            />
                          ) : (
                            <input
                              type="checkbox"
                              className="manual-entry-disabled-input"
                              readOnly
                              checked={
                                row.goods_type === "BREAKAGE" ? true : false
                              }
                            />
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                ref={divRef}
                                style={{
                                  width: "100%",
                                }}
                                value={div}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__div}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {row.medicine_master__plant}
                        </TableCell>

                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={packRef}
                                value={pack}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__pack_size}</div>
                          )}
                        </TableCell>

                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={mfgDateRef}
                                value={mfgDate}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__valid_from}</div>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={expiryDateRef}
                                value={expiryDate}
                              />
                            </div>
                          ) : (
                            <div>{row.medicine_master__date_of_expiry}</div>
                          )}
                        </TableCell>

                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "1em",
                            textAlign: "center",
                          }}
                        >
                          {editState &&
                          row.box_medicine_data_master_id === medId ? (
                            <div>
                              <input
                                className="manual-entry-disabled-input"
                                disabled={true}
                                style={{
                                  width: "100%",
                                }}
                                ref={dateRef}
                                value={row.created_on}
                              />
                            </div>
                          ) : (
                            <div>{formatDate(row.created_on)}</div>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            ) : (
              <div id="group_by_table_container"></div>
            )}
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
};

export default ManualEntryTable;
